import { render, staticRenderFns } from "./BlockType105.vue?vue&type=template&id=0a7238da&scoped=true&"
import script from "./BlockType105.vue?vue&type=script&lang=ts&"
export * from "./BlockType105.vue?vue&type=script&lang=ts&"
import style0 from "./BlockType105.vue?vue&type=style&index=0&id=0a7238da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7238da",
  null
  
)

export default component.exports